import React, { useState } from 'react';
import Navigation from '../Navigation';
import './index.less';

const Layout = ({ children }) => {
  const [currentPage, setCurrentPage] = useState('home');

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="layout-container">
      {/* 导航栏 */}
      <Navigation 
        currentPage={currentPage} 
        onPageChange={handlePageChange}
      />
      
      {/* 主内容区域 */}
      <div className="main-content">
        {children}
      </div>
    </div>
  );
};

export default Layout;